import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { ListItem } from './ListItem';
import { AddForum } from './AddForum';
import * as Config from '../../../configuration/consts';
var moment = require('moment');

@withRouter
export class ForumList extends React.Component<any, any> {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        if(this.props.currentUsersForums && this.props.currentUsersForums.length === 1){
            // if there is only one forum go straight to that forum
            this.props.history.push(`/DiscussionBoard?id=${this.props.currentUsersForums[0].id}`);
        }
    }
    
    render() {

        const { userRole, currentUser, currentUsersForums, ...props } = this.props;
        let isAdmin = userRole == Config.ROLE_GLOBAL_ADMIN;
        let sortedForums = currentUsersForums ? currentUsersForums.sort((a, b) => {
            if(a.rank > b.rank){
                return 1;
            } else if (a.rank < b.rank) {
                return -1;
            } else {
                return 0;
            }
        }) : undefined;

        let content = sortedForums ? sortedForums.map((item, index) => { 
            return <ListItem key={"" + index} item={item} {...this.props}/>; 
        }) : undefined;
        
        let addBoard = isAdmin ? <div className="row">
                                    <AddForum {...this.props} />
                                </div>  : undefined;

        let forumListConent = <div className="col-12 col-md-9">
                                {addBoard}
                                <div className="discussion-board-resource">
                                <div className="row mb-3">
                                    <div className="col-8">
                                        <h4>Discussion Boards</h4>
                                    </div>
                                </div>
                                {content}
                            </div>
                            </div>;

        return (forumListConent);
    }
}



// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Forum/List.tsx